module.exports = __webpack_public_path__ + "img/img-wip.4f650eb8.png";